/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateAgelessOnboardingLocationRequest,
  DisplayAgelessOnboardingCreatedLocationResponse,
  DisplayAgelessOnboardingLocationsResponse,
  DisplayAgelessOnboardingNotificationPhoneNumberResponse,
  DisplayAgelessOnboardingProgressResponse,
  DisplayAgelessServiceAreaResponse,
  DisplayAgelessWaitlistEntryResponse,
  DisplayFreePrintsForLifeStatusResponse,
  DisplayPlgOnboardingBrandingDomainLock,
  ProblemDetails,
  SaveAgelessServiceAreaForPlatformRequest,
  SetAgelessOnboardingLocationAddressRequest,
  SetAgelessOnboardingLocationBookingUrlRequest,
  SetAgelessOnboardingLocationNameRequest,
  SetAgelessOnboardingLocationOperatingHoursRequest,
  SetAgelessOnboardingLocationPhoneNumberRequest,
  SetAgelessOnboardingNotificationPhoneNumberRequest,
  SetAgelessOnboardingStepCompletedRequest,
  SetDomainForPlatformRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieve the free prints for life unlock status for a platform.
 */
export const getFreePrintsStatus = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayFreePrintsForLifeStatusResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/free-prints-status`, method: 'GET', signal
    },
      );
    }




export const getGetFreePrintsStatusQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/free-prints-status`
    ] as const;
    }


export const getGetFreePrintsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreePrintsStatusQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreePrintsStatus>>> = ({ signal }) => getFreePrintsStatus(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFreePrintsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getFreePrintsStatus>>>
export type GetFreePrintsStatusQueryError = ErrorType<unknown>


export function useGetFreePrintsStatus<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreePrintsStatus>>,
          TError,
          Awaited<ReturnType<typeof getFreePrintsStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreePrintsStatus<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreePrintsStatus>>,
          TError,
          Awaited<ReturnType<typeof getFreePrintsStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreePrintsStatus<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the free prints for life unlock status for a platform.
 */

export function useGetFreePrintsStatus<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFreePrintsStatusQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFreePrintsStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreePrintsStatusQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreePrintsStatus>>> = ({ signal }) => getFreePrintsStatus(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetFreePrintsStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFreePrintsStatus>>>
export type GetFreePrintsStatusSuspenseQueryError = ErrorType<unknown>


export function useGetFreePrintsStatusSuspense<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreePrintsStatusSuspense<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreePrintsStatusSuspense<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the free prints for life unlock status for a platform.
 */

export function useGetFreePrintsStatusSuspense<TData = Awaited<ReturnType<typeof getFreePrintsStatus>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreePrintsStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFreePrintsStatusSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Manually complete the free print challenge for a platform and unlock free prints.
Idempotent — the challenge-completed subscriber no-ops when the platform is already unlocked.
 */
export const unlockFreePrintsForPlatformForOnboarding = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/free-prints/unlock`, method: 'POST', signal
    },
      );
    }




export const getUnlockFreePrintsForPlatformForOnboardingMutationKey = () => ['unlockFreePrintsForPlatformForOnboarding'] as const;

export const getUnlockFreePrintsForPlatformForOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, TError,UnlockFreePrintsForPlatformForOnboardingMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, TError,UnlockFreePrintsForPlatformForOnboardingMutationVariables, TContext> => {

const mutationKey = getUnlockFreePrintsForPlatformForOnboardingMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, UnlockFreePrintsForPlatformForOnboardingMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  unlockFreePrintsForPlatformForOnboarding(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockFreePrintsForPlatformForOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>>

    export type UnlockFreePrintsForPlatformForOnboardingMutationError = ErrorType<unknown>
    export type UnlockFreePrintsForPlatformForOnboardingMutationVariables = {platformId: string}

    /**
 * @summary Manually complete the free print challenge for a platform and unlock free prints.
Idempotent — the challenge-completed subscriber no-ops when the platform is already unlocked.
 */
export const useUnlockFreePrintsForPlatformForOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>, TError,UnlockFreePrintsForPlatformForOnboardingMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlockFreePrintsForPlatformForOnboarding>>,
        TError,
        UnlockFreePrintsForPlatformForOnboardingMutationVariables,
        TContext
      > => {
      return useMutation(getUnlockFreePrintsForPlatformForOnboardingMutationOptions(options), queryClient);
    }
    /**
 * @summary Reads whether a completed Ageless assessment has made this platform's app URL permanent.
 */
export const getPlgOnboardingBrandingDomainLock = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayPlgOnboardingBrandingDomainLock>(
      {url: `/api/v1/ageless/onboarding/${platformId}/branding-domain-lock`, method: 'GET', signal
    },
      );
    }




export const getGetPlgOnboardingBrandingDomainLockQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/branding-domain-lock`
    ] as const;
    }


export const getGetPlgOnboardingBrandingDomainLockQueryOptions = <TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlgOnboardingBrandingDomainLockQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>> = ({ signal }) => getPlgOnboardingBrandingDomainLock(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlgOnboardingBrandingDomainLockQueryResult = NonNullable<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>>
export type GetPlgOnboardingBrandingDomainLockQueryError = ErrorType<ProblemDetails>


export function useGetPlgOnboardingBrandingDomainLock<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>,
          TError,
          Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingBrandingDomainLock<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>,
          TError,
          Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingBrandingDomainLock<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reads whether a completed Ageless assessment has made this platform's app URL permanent.
 */

export function useGetPlgOnboardingBrandingDomainLock<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlgOnboardingBrandingDomainLockQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPlgOnboardingBrandingDomainLockSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlgOnboardingBrandingDomainLockQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>> = ({ signal }) => getPlgOnboardingBrandingDomainLock(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPlgOnboardingBrandingDomainLockSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>>
export type GetPlgOnboardingBrandingDomainLockSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetPlgOnboardingBrandingDomainLockSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingBrandingDomainLockSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlgOnboardingBrandingDomainLockSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reads whether a completed Ageless assessment has made this platform's app URL permanent.
 */

export function useGetPlgOnboardingBrandingDomainLockSuspense<TData = Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPlgOnboardingBrandingDomainLock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlgOnboardingBrandingDomainLockSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieve the Ageless waitlist entry data for a platform during onboarding.
Returns null if not found.
 */
export const getWaitlistEntry = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessWaitlistEntryResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/waitlist`, method: 'GET', signal
    },
      );
    }




export const getGetWaitlistEntryQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/waitlist`
    ] as const;
    }


export const getGetWaitlistEntryQueryOptions = <TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWaitlistEntryQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWaitlistEntry>>> = ({ signal }) => getWaitlistEntry(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWaitlistEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getWaitlistEntry>>>
export type GetWaitlistEntryQueryError = ErrorType<unknown>


export function useGetWaitlistEntry<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWaitlistEntry>>,
          TError,
          Awaited<ReturnType<typeof getWaitlistEntry>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWaitlistEntry<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWaitlistEntry>>,
          TError,
          Awaited<ReturnType<typeof getWaitlistEntry>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWaitlistEntry<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the Ageless waitlist entry data for a platform during onboarding.
Returns null if not found.
 */

export function useGetWaitlistEntry<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWaitlistEntryQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWaitlistEntrySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWaitlistEntryQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWaitlistEntry>>> = ({ signal }) => getWaitlistEntry(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWaitlistEntrySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWaitlistEntry>>>
export type GetWaitlistEntrySuspenseQueryError = ErrorType<unknown>


export function useGetWaitlistEntrySuspense<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWaitlistEntrySuspense<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWaitlistEntrySuspense<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the Ageless waitlist entry data for a platform during onboarding.
Returns null if not found.
 */

export function useGetWaitlistEntrySuspense<TData = Awaited<ReturnType<typeof getWaitlistEntry>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWaitlistEntry>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWaitlistEntrySuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieve the Ageless onboarding progress for a platform.
 */
export const getProgress = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessOnboardingProgressResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/progress`, method: 'GET', signal
    },
      );
    }




export const getGetProgressQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/progress`
    ] as const;
    }


export const getGetProgressQueryOptions = <TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgressQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgress>>> = ({ signal }) => getProgress(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getProgress>>>
export type GetProgressQueryError = ErrorType<unknown>


export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgress>>,
          TError,
          Awaited<ReturnType<typeof getProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProgress>>,
          TError,
          Awaited<ReturnType<typeof getProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the Ageless onboarding progress for a platform.
 */

export function useGetProgress<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProgressQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProgressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProgressQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProgress>>> = ({ signal }) => getProgress(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProgressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProgress>>>
export type GetProgressSuspenseQueryError = ErrorType<unknown>


export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the Ageless onboarding progress for a platform.
 */

export function useGetProgressSuspense<TData = Awaited<ReturnType<typeof getProgress>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProgressSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Mark an Ageless onboarding step as completed for a platform.
 */
export const setStepCompleted = (
    platformId: string,
    setAgelessOnboardingStepCompletedRequest: SetAgelessOnboardingStepCompletedRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/progress`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingStepCompletedRequest, signal
    },
      );
    }




export const getSetStepCompletedMutationKey = () => ['setStepCompleted'] as const;

export const getSetStepCompletedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStepCompleted>>, TError,SetStepCompletedMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setStepCompleted>>, TError,SetStepCompletedMutationVariables, TContext> => {

const mutationKey = getSetStepCompletedMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setStepCompleted>>, SetStepCompletedMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setStepCompleted(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetStepCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof setStepCompleted>>>
    export type SetStepCompletedMutationBody = SetAgelessOnboardingStepCompletedRequest
    export type SetStepCompletedMutationError = ErrorType<ProblemDetails>
    export type SetStepCompletedMutationVariables = {platformId: string;data: SetAgelessOnboardingStepCompletedRequest}

    /**
 * @summary Mark an Ageless onboarding step as completed for a platform.
 */
export const useSetStepCompleted = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setStepCompleted>>, TError,SetStepCompletedMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setStepCompleted>>,
        TError,
        SetStepCompletedMutationVariables,
        TContext
      > => {
      return useMutation(getSetStepCompletedMutationOptions(options), queryClient);
    }
    /**
 * @summary Set the domain for a platform during Ageless onboarding.
 */
export const setDomain = (
    platformId: string,
    setDomainForPlatformRequest: SetDomainForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/domain`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDomainForPlatformRequest, signal
    },
      );
    }




export const getSetDomainMutationKey = () => ['setDomain'] as const;

export const getSetDomainMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDomain>>, TError,SetDomainMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setDomain>>, TError,SetDomainMutationVariables, TContext> => {

const mutationKey = getSetDomainMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDomain>>, SetDomainMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setDomain(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDomainMutationResult = NonNullable<Awaited<ReturnType<typeof setDomain>>>
    export type SetDomainMutationBody = SetDomainForPlatformRequest
    export type SetDomainMutationError = ErrorType<ProblemDetails>
    export type SetDomainMutationVariables = {platformId: string;data: SetDomainForPlatformRequest}

    /**
 * @summary Set the domain for a platform during Ageless onboarding.
 */
export const useSetDomain = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDomain>>, TError,SetDomainMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDomain>>,
        TError,
        SetDomainMutationVariables,
        TContext
      > => {
      return useMutation(getSetDomainMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieve the admin Ageless notification phone number for the current person.
 */
export const getNotificationPhoneNumber = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessOnboardingNotificationPhoneNumberResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/notification-phone-number`, method: 'GET', signal
    },
      );
    }




export const getGetNotificationPhoneNumberQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/notification-phone-number`
    ] as const;
    }


export const getGetNotificationPhoneNumberQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationPhoneNumberQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPhoneNumber>>> = ({ signal }) => getNotificationPhoneNumber(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationPhoneNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationPhoneNumber>>>
export type GetNotificationPhoneNumberQueryError = ErrorType<ProblemDetails>


export function useGetNotificationPhoneNumber<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getNotificationPhoneNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationPhoneNumber<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getNotificationPhoneNumber>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationPhoneNumber<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the admin Ageless notification phone number for the current person.
 */

export function useGetNotificationPhoneNumber<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationPhoneNumberQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetNotificationPhoneNumberSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationPhoneNumberQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPhoneNumber>>> = ({ signal }) => getNotificationPhoneNumber(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetNotificationPhoneNumberSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationPhoneNumber>>>
export type GetNotificationPhoneNumberSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetNotificationPhoneNumberSuspense<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationPhoneNumberSuspense<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationPhoneNumberSuspense<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the admin Ageless notification phone number for the current person.
 */

export function useGetNotificationPhoneNumberSuspense<TData = Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNotificationPhoneNumber>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationPhoneNumberSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Set the admin Ageless notification phone number for the current person.
 */
export const setNotificationPhoneNumber = (
    platformId: string,
    setAgelessOnboardingNotificationPhoneNumberRequest: SetAgelessOnboardingNotificationPhoneNumberRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/notification-phone-number`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingNotificationPhoneNumberRequest, signal
    },
      );
    }




export const getSetNotificationPhoneNumberMutationKey = () => ['setNotificationPhoneNumber'] as const;

export const getSetNotificationPhoneNumberMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, TError,SetNotificationPhoneNumberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, TError,SetNotificationPhoneNumberMutationVariables, TContext> => {

const mutationKey = getSetNotificationPhoneNumberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, SetNotificationPhoneNumberMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  setNotificationPhoneNumber(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetNotificationPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof setNotificationPhoneNumber>>>
    export type SetNotificationPhoneNumberMutationBody = SetAgelessOnboardingNotificationPhoneNumberRequest
    export type SetNotificationPhoneNumberMutationError = ErrorType<ProblemDetails>
    export type SetNotificationPhoneNumberMutationVariables = {platformId: string;data: SetAgelessOnboardingNotificationPhoneNumberRequest}

    /**
 * @summary Set the admin Ageless notification phone number for the current person.
 */
export const useSetNotificationPhoneNumber = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setNotificationPhoneNumber>>, TError,SetNotificationPhoneNumberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setNotificationPhoneNumber>>,
        TError,
        SetNotificationPhoneNumberMutationVariables,
        TContext
      > => {
      return useMutation(getSetNotificationPhoneNumberMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieve all locations for a platform during onboarding.
 */
export const getLocations = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessOnboardingLocationsResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations`, method: 'GET', signal
    },
      );
    }




export const getGetLocationsQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/locations`
    ] as const;
    }


export const getGetLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocations>>> = ({ signal }) => getLocations(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocations>>>
export type GetLocationsQueryError = ErrorType<unknown>


export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocations>>,
          TError,
          Awaited<ReturnType<typeof getLocations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocations>>,
          TError,
          Awaited<ReturnType<typeof getLocations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve all locations for a platform during onboarding.
 */

export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationsQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLocationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocations>>> = ({ signal }) => getLocations(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLocationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLocations>>>
export type GetLocationsSuspenseQueryError = ErrorType<unknown>


export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve all locations for a platform during onboarding.
 */

export function useGetLocationsSuspense<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationsSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a new location for a platform during onboarding.
 */
export const createLocation = (
    platformId: string,
    createAgelessOnboardingLocationRequest: CreateAgelessOnboardingLocationRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessOnboardingCreatedLocationResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAgelessOnboardingLocationRequest, signal
    },
      );
    }




export const getCreateLocationMutationKey = () => ['createLocation'] as const;

export const getCreateLocationMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,CreateLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,CreateLocationMutationVariables, TContext> => {

const mutationKey = getCreateLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocation>>, CreateLocationMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  createLocation(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createLocation>>>
    export type CreateLocationMutationBody = CreateAgelessOnboardingLocationRequest
    export type CreateLocationMutationError = ErrorType<ProblemDetails>
    export type CreateLocationMutationVariables = {platformId: string;data: CreateAgelessOnboardingLocationRequest}

    /**
 * @summary Create a new location for a platform during onboarding.
 */
export const useCreateLocation = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,CreateLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLocation>>,
        TError,
        CreateLocationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLocationMutationOptions(options), queryClient);
    }
    /**
 * @summary Set the name for a platform location during onboarding.
 */
export const setLocationName = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationNameRequest: SetAgelessOnboardingLocationNameRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationNameRequest, signal
    },
      );
    }




export const getSetLocationNameMutationKey = () => ['setLocationName'] as const;

export const getSetLocationNameMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationName>>, TError,SetLocationNameMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationName>>, TError,SetLocationNameMutationVariables, TContext> => {

const mutationKey = getSetLocationNameMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationName>>, SetLocationNameMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationName(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLocationNameMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationName>>>
    export type SetLocationNameMutationBody = SetAgelessOnboardingLocationNameRequest
    export type SetLocationNameMutationError = ErrorType<ProblemDetails>
    export type SetLocationNameMutationVariables = {platformId: string;locationId: string;data: SetAgelessOnboardingLocationNameRequest}

    /**
 * @summary Set the name for a platform location during onboarding.
 */
export const useSetLocationName = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationName>>, TError,SetLocationNameMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLocationName>>,
        TError,
        SetLocationNameMutationVariables,
        TContext
      > => {
      return useMutation(getSetLocationNameMutationOptions(options), queryClient);
    }
    /**
 * @summary Set the physical address for a platform location during onboarding.
 */
export const setLocationAddress = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationAddressRequest: SetAgelessOnboardingLocationAddressRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/address`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationAddressRequest, signal
    },
      );
    }




export const getSetLocationAddressMutationKey = () => ['setLocationAddress'] as const;

export const getSetLocationAddressMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationAddress>>, TError,SetLocationAddressMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationAddress>>, TError,SetLocationAddressMutationVariables, TContext> => {

const mutationKey = getSetLocationAddressMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationAddress>>, SetLocationAddressMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationAddress(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLocationAddressMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationAddress>>>
    export type SetLocationAddressMutationBody = SetAgelessOnboardingLocationAddressRequest
    export type SetLocationAddressMutationError = ErrorType<ProblemDetails>
    export type SetLocationAddressMutationVariables = {platformId: string;locationId: string;data: SetAgelessOnboardingLocationAddressRequest}

    /**
 * @summary Set the physical address for a platform location during onboarding.
 */
export const useSetLocationAddress = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationAddress>>, TError,SetLocationAddressMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLocationAddress>>,
        TError,
        SetLocationAddressMutationVariables,
        TContext
      > => {
      return useMutation(getSetLocationAddressMutationOptions(options), queryClient);
    }
    /**
 * @summary Set the phone number for a platform location during onboarding.
 */
export const setLocationPhoneNumber = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationPhoneNumberRequest: SetAgelessOnboardingLocationPhoneNumberRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/phone-number`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationPhoneNumberRequest, signal
    },
      );
    }




export const getSetLocationPhoneNumberMutationKey = () => ['setLocationPhoneNumber'] as const;

export const getSetLocationPhoneNumberMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationPhoneNumber>>, TError,SetLocationPhoneNumberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationPhoneNumber>>, TError,SetLocationPhoneNumberMutationVariables, TContext> => {

const mutationKey = getSetLocationPhoneNumberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationPhoneNumber>>, SetLocationPhoneNumberMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationPhoneNumber(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLocationPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationPhoneNumber>>>
    export type SetLocationPhoneNumberMutationBody = SetAgelessOnboardingLocationPhoneNumberRequest
    export type SetLocationPhoneNumberMutationError = ErrorType<ProblemDetails>
    export type SetLocationPhoneNumberMutationVariables = {platformId: string;locationId: string;data: SetAgelessOnboardingLocationPhoneNumberRequest}

    /**
 * @summary Set the phone number for a platform location during onboarding.
 */
export const useSetLocationPhoneNumber = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationPhoneNumber>>, TError,SetLocationPhoneNumberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLocationPhoneNumber>>,
        TError,
        SetLocationPhoneNumberMutationVariables,
        TContext
      > => {
      return useMutation(getSetLocationPhoneNumberMutationOptions(options), queryClient);
    }
    /**
 * @summary Set the booking URL for a platform location during onboarding.
 */
export const setLocationBookingUrl = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationBookingUrlRequest: SetAgelessOnboardingLocationBookingUrlRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/booking-url`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationBookingUrlRequest, signal
    },
      );
    }




export const getSetLocationBookingUrlMutationKey = () => ['setLocationBookingUrl'] as const;

export const getSetLocationBookingUrlMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationBookingUrl>>, TError,SetLocationBookingUrlMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationBookingUrl>>, TError,SetLocationBookingUrlMutationVariables, TContext> => {

const mutationKey = getSetLocationBookingUrlMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationBookingUrl>>, SetLocationBookingUrlMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationBookingUrl(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLocationBookingUrlMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationBookingUrl>>>
    export type SetLocationBookingUrlMutationBody = SetAgelessOnboardingLocationBookingUrlRequest
    export type SetLocationBookingUrlMutationError = ErrorType<ProblemDetails>
    export type SetLocationBookingUrlMutationVariables = {platformId: string;locationId: string;data: SetAgelessOnboardingLocationBookingUrlRequest}

    /**
 * @summary Set the booking URL for a platform location during onboarding.
 */
export const useSetLocationBookingUrl = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationBookingUrl>>, TError,SetLocationBookingUrlMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLocationBookingUrl>>,
        TError,
        SetLocationBookingUrlMutationVariables,
        TContext
      > => {
      return useMutation(getSetLocationBookingUrlMutationOptions(options), queryClient);
    }
    /**
 * @summary Set operating hours for a platform location during onboarding.
 */
export const setLocationOperatingHours = (
    platformId: string,
    locationId: string,
    setAgelessOnboardingLocationOperatingHoursRequest: SetAgelessOnboardingLocationOperatingHoursRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/locations/${locationId}/operating-hours`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgelessOnboardingLocationOperatingHoursRequest, signal
    },
      );
    }




export const getSetLocationOperatingHoursMutationKey = () => ['setLocationOperatingHours'] as const;

export const getSetLocationOperatingHoursMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationOperatingHours>>, TError,SetLocationOperatingHoursMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setLocationOperatingHours>>, TError,SetLocationOperatingHoursMutationVariables, TContext> => {

const mutationKey = getSetLocationOperatingHoursMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLocationOperatingHours>>, SetLocationOperatingHoursMutationVariables> = (props) => {
          const {platformId,locationId,data} = props ?? {};

          return  setLocationOperatingHours(platformId,locationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLocationOperatingHoursMutationResult = NonNullable<Awaited<ReturnType<typeof setLocationOperatingHours>>>
    export type SetLocationOperatingHoursMutationBody = SetAgelessOnboardingLocationOperatingHoursRequest
    export type SetLocationOperatingHoursMutationError = ErrorType<ProblemDetails>
    export type SetLocationOperatingHoursMutationVariables = {platformId: string;locationId: string;data: SetAgelessOnboardingLocationOperatingHoursRequest}

    /**
 * @summary Set operating hours for a platform location during onboarding.
 */
export const useSetLocationOperatingHours = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLocationOperatingHours>>, TError,SetLocationOperatingHoursMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLocationOperatingHours>>,
        TError,
        SetLocationOperatingHoursMutationVariables,
        TContext
      > => {
      return useMutation(getSetLocationOperatingHoursMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieve the Ageless service area configuration for a platform.
 */
export const getServiceArea = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessServiceAreaResponse>(
      {url: `/api/v1/ageless/onboarding/${platformId}/service-area`, method: 'GET', signal
    },
      );
    }




export const getGetServiceAreaQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/onboarding/${platformId}/service-area`
    ] as const;
    }


export const getGetServiceAreaQueryOptions = <TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAreaQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceArea>>> = ({ signal }) => getServiceArea(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceAreaQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceArea>>>
export type GetServiceAreaQueryError = ErrorType<unknown>


export function useGetServiceArea<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceArea>>,
          TError,
          Awaited<ReturnType<typeof getServiceArea>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceArea<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceArea>>,
          TError,
          Awaited<ReturnType<typeof getServiceArea>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceArea<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the Ageless service area configuration for a platform.
 */

export function useGetServiceArea<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAreaQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetServiceAreaSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceAreaQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceArea>>> = ({ signal }) => getServiceArea(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetServiceAreaSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceArea>>>
export type GetServiceAreaSuspenseQueryError = ErrorType<unknown>


export function useGetServiceAreaSuspense<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAreaSuspense<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceAreaSuspense<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the Ageless service area configuration for a platform.
 */

export function useGetServiceAreaSuspense<TData = Awaited<ReturnType<typeof getServiceArea>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServiceArea>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceAreaSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Define or update the Ageless service area for a platform.
 */
export const saveServiceArea = (
    platformId: string,
    saveAgelessServiceAreaForPlatformRequest: SaveAgelessServiceAreaForPlatformRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/onboarding/${platformId}/service-area`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveAgelessServiceAreaForPlatformRequest, signal
    },
      );
    }




export const getSaveServiceAreaMutationKey = () => ['saveServiceArea'] as const;

export const getSaveServiceAreaMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveServiceArea>>, TError,SaveServiceAreaMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveServiceArea>>, TError,SaveServiceAreaMutationVariables, TContext> => {

const mutationKey = getSaveServiceAreaMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveServiceArea>>, SaveServiceAreaMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  saveServiceArea(platformId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveServiceAreaMutationResult = NonNullable<Awaited<ReturnType<typeof saveServiceArea>>>
    export type SaveServiceAreaMutationBody = SaveAgelessServiceAreaForPlatformRequest
    export type SaveServiceAreaMutationError = ErrorType<ProblemDetails>
    export type SaveServiceAreaMutationVariables = {platformId: string;data: SaveAgelessServiceAreaForPlatformRequest}

    /**
 * @summary Define or update the Ageless service area for a platform.
 */
export const useSaveServiceArea = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveServiceArea>>, TError,SaveServiceAreaMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveServiceArea>>,
        TError,
        SaveServiceAreaMutationVariables,
        TContext
      > => {
      return useMutation(getSaveServiceAreaMutationOptions(options), queryClient);
    }
